import React, { useState, useEffect, useContext, useRef } from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import {
  FaBell,
  FaCog,
  FaUserCircle
} from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import AppContext from '../../context/AppContext';
import '../../assets/css/layout/customer/CustomerHeader.css';

const CustomerHeader = () => {

  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown]   = useState(false);
  const dropdownRef = useRef(null);

  const viewLatestNotifications = (loggedInCustomer) => {
    const formData = new FormData();
    formData.append('wecustomer_id', loggedInCustomer.id);

    axios.post(`${baseUrl}/customer/notifications/viewAllNotifications`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => {
      if (res.data.success === true) {
        const sorted = [...res.data.notifications].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setNotifications(sorted.slice(0, 3));
      }
    })
    .catch((err) => console.log(err));
  };

  useEffect(() => {
    const loggedInCustomer = JSON.parse(localStorage.getItem('loggedInCustomer'));
    if (loggedInCustomer) {
      viewLatestNotifications(loggedInCustomer);
    }
  }, []);

  const handleBellClick = () => {
    const opening = !showDropdown;
    setShowDropdown(opening);

    if (opening) {
      const loggedInCustomer = JSON.parse(localStorage.getItem('loggedInCustomer'));
      if (loggedInCustomer) {
        viewLatestNotifications(loggedInCustomer);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const unreadCount = notifications.filter(n => n.status === 'unread').length;

  return (
    <header className="customer-header-ch">
      <Container fluid>
        <Row className="align-items-center">
          {/* Left Side - Logo/Brand */}
          <Col xs={6} md={4} lg={3}>
            <div className="header-brand-ch">
              <div className="brand-icon-ch">E</div>
              <div className="brand-info-ch">
                <h1 className="brand-title-ch">EVENTLY</h1>
                <p className="brand-subtitle-ch">Customer Panel</p>
              </div>
            </div>
          </Col>

          {/* Right Side - Action Icons */}
          <Col xs={6} md={8} lg={9} className="text-end">
            <div className="header-actions-ch">

              <div className="notification-wrapper-ch" ref={dropdownRef}>
                <button
                  className="header-icon-btn-ch"
                  aria-label="Notifications"
                  onClick={handleBellClick}
                >
                  <FaBell />
                  {unreadCount > 0 && (
                    <Badge bg="danger" pill className="notification-count-badge-ch">
                      {unreadCount}
                    </Badge>
                  )}
                </button>

                {showDropdown && (
                  <div className="notification-dropdown-ch">
                    <div className="notification-dropdown-header-ch">
                      <span>Notifications</span>
                      {unreadCount > 0 && (
                        <Badge bg="light" text="dark">{unreadCount} new</Badge>
                      )}
                    </div>

                    {notifications.length === 0 ? (
                      <div className="notification-dropdown-empty-ch">
                        <FaBell />
                        <p>No Notifications</p>
                      </div>
                    ) : (
                      <div className="notification-dropdown-list-ch">
                        {notifications.map((notification) => (
                          <div
                            key={notification.id}
                            className={`notification-dropdown-item-ch ${notification.status === 'unread' ? 'unread-ch' : ''}`}
                            onClick={() => {
                              setShowDropdown(false);
                              navigate('/customer/notifications');
                            }}
                          >
                            <strong>{notification.title}</strong>
                            <p>{notification.descrption}</p>
                            <span>{notification.created_at?.slice(0, 10)}</span>
                          </div>
                        ))}
                      </div>
                    )}

                    <div
                      className="notification-dropdown-footer-ch"
                      onClick={() => {
                        setShowDropdown(false);
                        navigate('/customer/notifications');
                      }}
                    >
                      View All Notifications
                    </div>
                  </div>
                )}
              </div>

              {/* <button
                className="header-icon-btn-ch"
                aria-label="Settings"
                onClick={() => navigate("/customer/settings")}
              >
                <FaCog />
              </button> */}

              <button
                type="button"
                className="header-icon-btn-ch admin-btn-ch"
                aria-label="Profile"
                onClick={() => navigate("/customer/profile")}
              >
                <FaUserCircle />
                <span className="admin-label-ch">Customer</span>
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default CustomerHeader;